import { wpApiInstance} from '../api/wp-api';
import { awsApiInstance } from '../api/aws-api';
import { encryptData } from '../auth/encrypt-data';

import { IUserWpNew, IUserAwsNew, IPostNewUser, IWPPostUser } from '../models/user.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Posts a new user in WordPress.
 * 
 * @param {IUserWpNew} user the form data
 */
const wpPostNewUser = async (user: IUserWpNew): Promise<IWPPostUser> => {
  try {
    const modelData = {
      newUserName: user.newUserName,
      newUserFirstName: user.newUserFirstName,
      newUserLastName: user.newUserLastName,
      newUserEmail: user.newUserEmail,
      newUserStatus: user.newUserStatus,
      newUserRole: user.newUserRole
    };

    const { data } = await wpApiInstance.post('/admin/users', { json: modelData });

    return data;
  } catch (error) {
    handleRouteError(error, 'Error creating new user');
    throw(error);
  }
}

/**
 * Posts a new user in the database. This is the AWS database
 * not Cognito.  User are reginstered in Cognito when they
 * do a password reset.
 * 
 * @param {IUserAwsNew} user the form data
 * 
 * @returns {IPostNewUser} the api response | error
 */
const awsPostNewUser = async (user: IUserAwsNew): Promise<IPostNewUser> => {
  try {
    const modelData = {
      wpID: user.wpId,
      wpName: user.wpName,
      accessLevel: user.accessLevel,
      accessType: user.accessType,
      idArray: user.idArray,
      adminId: user.adminId
    };

    const token = encryptData(user.userEmail);

    const modalDataSignUp = {
      request: JSON.stringify(token)
    };

    const [ awsResponseSign, awsResponse ] = await Promise.all([
      awsApiInstance.post(`/auth/user`, modalDataSignUp),
      awsApiInstance.post(`/user`, modelData )
    ]);

    return awsResponse.data;
  } catch ( error ) {
    handleRouteError(error, 'Error creating new user');
    throw(error);
  }
}
 
export { wpPostNewUser, awsPostNewUser };